import _101_N from "@/img/weather-icon/_101_N.svg";
import _101 from "@/img/weather-icon/_101.svg";
import _103_N from "@/img/weather-icon/_103_N.svg";
import _103 from "@/img/weather-icon/_103.svg";
import _121_N from "@/img/weather-icon/_121_N.svg";
import _121 from "@/img/weather-icon/_121.svg";
import _141_N from "@/img/weather-icon/_141_N.svg";
import _141 from "@/img/weather-icon/_141.svg";
import _151_N from "@/img/weather-icon/_151_N.svg";
import _151 from "@/img/weather-icon/_151.svg";
import _132_N from "@/img/weather-icon/_132_N.svg";
import _132 from "@/img/weather-icon/_132.svg";
import _301_N from "@/img/weather-icon/_301_N.svg";
import _301 from "@/img/weather-icon/_301.svg";
import _131_N from "@/img/weather-icon/_131_N.svg";
import _131 from "@/img/weather-icon/_131.svg";
import _212_N from "@/img/weather-icon/_212_N.svg";
import _212 from "@/img/weather-icon/_212.svg";
import _215_N from "@/img/weather-icon/_215_N.svg";
import _215 from "@/img/weather-icon/_215.svg";
import _220_N from "@/img/weather-icon/_220_N.svg";
import _220 from "@/img/weather-icon/_220.svg";
import _202_N from "@/img/weather-icon/_202_N.svg";
import _202 from "@/img/weather-icon/_202.svg";
import _204_N from "@/img/weather-icon/_204_N.svg";
import _204 from "@/img/weather-icon/_204.svg";
import _208_N from "@/img/weather-icon/_208_N.svg";
import _208 from "@/img/weather-icon/_208.svg";
import _304_N from "@/img/weather-icon/_304_N.svg";
import _304 from "@/img/weather-icon/_304.svg";
import _308_N from "@/img/weather-icon/_308_N.svg";
import _308 from "@/img/weather-icon/_308.svg";

import _100_N from "@/img/weather-icon/_100_N.svg";
import _100 from "@/img/weather-icon/_100.svg";

const WEATHER_ICONS: Record<number, { day: string; night: string }> = {
	101: { day: _101, night: _101_N },
	103: { day: _103, night: _103_N },
	121: { day: _121, night: _121_N },
	141: { day: _141, night: _141_N },
	151: { day: _151, night: _151_N },
	132: { day: _132, night: _132_N },
	301: { day: _301, night: _301_N },
	131: { day: _131, night: _131_N },
	212: { day: _212, night: _212_N },
	215: { day: _215, night: _215_N },
	220: { day: _220, night: _220_N },
	202: { day: _202, night: _202_N },
	204: { day: _204, night: _204_N },
	208: { day: _208, night: _208_N },
	304: { day: _304, night: _304_N },
	308: { day: _308, night: _308_N },
	100: { day: _100, night: _100_N },
};

export const formatWeatherStateIcon = ({
	timeStep,
	status,
}: {
	timeStep: string;
	status?: number;
}): string | undefined => {
	if (!status) return undefined;

	const hour = new Date(timeStep).getHours();
	const isNight = hour < 6 || hour >= 20;

	return WEATHER_ICONS[status]?.[isNight ? "night" : "day"];
};

export const getStatusTextByWW = (code?: number) => {
	let status;

	if (!code) {
		return "";
	}

	switch (code) {
		case 101:
			status = "Clear";
			break;
		case 103:
			status = "Clear";
			break;
		case 121:
			status = "Partly cloudy";
			break;
		case 141:
			status = "Mostly cloudy";
			break;
		case 151:
			status = "Overcast";
			break;
		case 132:
			status = "Fog";
			break;
		case 131:
			status = "Mist";
			break;
		case 202:
			status = "Light showers";
			break;
		case 212:
			status = "Overcast with light rain";
			break;
		case 204:
			status = "Showers";
			break;
		case 215:
			status = "Overcast with rain";
			break;
		case 208:
			status = "Heavy showers";
			break;
		case 220:
			status = "Overcast with heavy rain";
			break;
		case 301:
			status = "Dry thunderstorm";
			break;
		case 304:
			status = "Thunderstorm with rain";
			break;
		case 308:
			status = "Thunderstorm with heavy rain";
			break;
		default:
			status = "";
	}

	return status;
};
